// src/components/ServiceSlider.jsx
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";

const ServiceSlider = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get API configuration from localStorage
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "1"); // Type 1 for show all services

      const response = await fetch(`${api_url}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServices(data.result || []);
        setError(null);
      } else {
        setError(data.error || "Failed to fetch services");
        setServices([]);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError("Network error. Please check your connection.");
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  // Strip HTML tags for preview
  const stripHtmlTags = (html) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Truncate text
  const truncateText = (text, maxLength = 120) => {
    const stripped = stripHtmlTags(text);
    if (stripped.length <= maxLength) return stripped;
    return stripped.substring(0, maxLength) + "...";
  };

  // Get icon class based on service ID or use default
  const getServiceIcon = (index) => {
    const icons = [
      "icon-goal",
      "icon-financial-profit",
      "icon-strategy",
      "icon-agreement-1",
      "icon-reporting",
      "icon-risk-management",
      "icon-chart",
      "icon-consulting",
      "icon-handshake",
    ];
    return icons[index % icons.length];
  };

  if (loading) {
    return (
      <section className="services-layout9 pt-50 pb-50 section-full-width overflow-x-hidden">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div style={{ padding: "60px 0", color: "#666" }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p style={{ marginTop: "15px" }}>Loading services...</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error && services.length === 0) {
    return (
      <section className="services-layout9 pt-50 pb-50 section-full-width overflow-x-hidden">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div style={{ padding: "60px 0", color: "#666" }}>
                <p style={{ color: "#d32f2f", marginBottom: "20px" }}>
                  {error}
                </p>
                <button
                  onClick={fetchServices}
                  className="btn btn-primary"
                  style={{ padding: "10px 30px" }}
                >
                  Retry
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (services.length === 0) {
    return (
      <section className="services-layout9 pt-50 pb-50 section-full-width overflow-x-hidden">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div style={{ padding: "60px 0", color: "#666" }}>
                <p>No services available at the moment.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="services-layout9 pt-50 section-full-width overflow-x-hidden">
      <div className="container">
        <div className="row mb-40">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="heading-layout2">
              {/* <h2 className="heading-subtitle">
                A global strategy designed to solve tomorrow's challenges.
              </h2> */}
              <h3 className="heading-title text-wrap-balance">
                Your Business, Our Expertise — Accounting & Tax Support,
                Integrated with Your Team
              </h3>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 d-flex align-items-center justify-content-lg-end gap-50">
            <Link
              to="/services"
              className="btn btn-secondary btn-link btn-underlined arrow-hover-flip-up"
            >
              <span>Explore Our Services</span>
              <svg
                className="arrow-flip"
                viewBox="0 0 64 64"
                width="10"
                height="10"
              >
                <g className="arrow-flip-path-1">
                  <path
                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                    fill="currentColor"
                  ></path>
                </g>
                <g className="arrow-flip-path-2">
                  <path
                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                    fill="currentColor"
                  ></path>
                </g>
              </svg>
            </Link>
            <div className="d-flex">
              <div
                id="services-next"
                className="swiper-button-prev-2 icon-arrow-left position-static"
              ></div>
              <div
                id="services-prev"
                className="swiper-button-next-2 icon-arrow-right position-static"
              ></div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Swiper
              modules={[Navigation, Autoplay]}
              slidesPerView={1}
              spaceBetween={10}
              autoplay={{
                delay: 7000,
                disableOnInteraction: false,
              }}
              watchSlidesProgress={true}
              loop={services.length > 1} // Only loop if more than 1 service
              navigation={{
                nextEl: "#services-next",
                prevEl: "#services-prev",
              }}
              breakpoints={{
                600: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
            >
              {services.map((service, index) => (
                <SwiperSlide key={service.service_id}>
                  <div className="service-item" style={{ height: "500px;" }}>
                    <div className="service-body serviceBox">
                      <div className="service-icon">
                        <i className={getServiceIcon(index)}></i>
                      </div>
                      <h4 className="service-title">
                        <Link to={`/serviceDetails/${service.service_id}`}>
                          {service.service_title}
                        </Link>
                      </h4>

                      <p className="service-desc text-truncate-3">
                        {truncateText(service.service_short_dec, 120)}
                      </p>
                    </div>
                    <Link
                      to={`/serviceDetails/${service.service_id}`}
                      className="btn btn-primary same-hover arrow-hover-flip-up"
                    >
                      <svg
                        className="arrow-flip"
                        viewBox="0 0 64 64"
                        width="12"
                        height="12"
                      >
                        <g className="arrow-flip-path-1">
                          <path
                            d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <g className="arrow-flip-path-2">
                          <path
                            d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                            fill="currentColor"
                          ></path>
                        </g>
                      </svg>
                    </Link>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSlider;
